// extracted by mini-css-extract-plugin
export default {"container":"user_menu_container__KTiTX","avatar":"user_menu_avatar__xg-Sm"};